import { render, staticRenderFns } from "./CityReference.vue?vue&type=template&id=1908172b"
import script from "./CityReference.vue?vue&type=script&lang=js"
export * from "./CityReference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports